import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { Title } from 'components/Title';

import DepositSchedule from './DepositSchedule'
export default function RecurringSchPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [policyno, setPolicyno] = useState('');
	return (
		<main id="RecurringSchPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('recurringSch')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="md:col-6 col-12">
                        <div className="formgrid grid">
                            <div className="col-12 md:col-3">
                                {$t('policyno')} *
                            </div>
                            <div className="col-12 md:col-9">
                                <DataSource apiPath="components_data/policyno_option_list_30">
                                    {({ response }) => {
                                    const dropdownOptions = response?.map(x => ({
                                    label: x.policyno || x.label,
                                    value: x.policyno || x.value
                                    })) || [];
                                    return (
                                    <Dropdown
                                    value={policyno}
                                    onChange={(e) => setPolicyno(e.value)}
                                    options={dropdownOptions}
                                    optionLabel="label"
                                    optionValue="value"
                                    filter
                                    showClear
                                    />
                                    );
                                    }}
                                </DataSource>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="">
                    <div><DepositSchedule policyno= {policyno} /></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
